import React from 'react';
import Button from '../../Button/Button';

function ResultSection() {
  return (
        <section className="section-pad overflow-hidden results md:mt-0 bg-[#fff]">
             <div className="container mx-auto px-2 py-0 md:pb-0 pb-4.5">
                
                <h3 className="uppercase text-center text-[#212121] text-16 tracking-[1.2px] pb-1 pt-4 font-secondary leading-6" data-aos="fade-up">Insurance Leveraging Vymo
                </h3>
                <h2 className="font-main text-[#212121] text-center text-[26px] md:text-[32px] font-bold tracking-normal leading-[26px] md:leading-[38px]" data-aos="fade-up">Real results, real business</h2>

                <div className="flex flex-col lg:flex-row items-center lg:items-start gap-0 md:gap-4 mt-4 md:mt-6 pt-1">
                    <div className="text-left w-full md:w-1/2" data-aos="fade-up" data-aos-delay="200">
                        <a href="#!">
                            <div className="resource-box md:pr-6">
                                <p className="text-16 font-medium leading-6 text-left text-[#212121] opacity-80 pb-1">Vymo, Inc. is a global provider of an advanced distribution management platform meticulously crafted for insurers, MGAs, FMOs, IMOs, and insurance distributors who have outgrown legacy sales and account management tools and require greater automation for producer administration and sales processes.</p>
                                <p className="text-16 font-medium leading-6 text-left text-[#212121] opacity-80 pb-1">Vymo's platform features a suite of modular applications – including OnboardIQ and EngageIQ, and is engineered to deliver a superior producer experience through critical steps in the sales process, such as onboarding, compliance, activity tracking, and sales enablement.</p>
                                <p><a href="#!" className="font-secondary blue-btn text-[16px] text-[#212121] opacity-80 hover:text-[#000] underline underline-offset-4 font-medium">Learn more</a> →</p>
                            </div>
                        </a>
                    </div>
                    <div className="text-left w-full md:w-1/2" data-aos="fade-up" data-aos-delay="200">
                        <a href="#!">
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-6 md:mt-2">
                                <div className="result-box">
                                    <h3 className="text-center md:text-left text-[40px] font-secondary font-bold leading-[42px]">70+</h3>
                                    <p className="text-18 font-medium leading-6 text-center md:text-left text-black opacity-80 pt-1 pb-1">Enterprise Deployments</p>
                                </div>
                                <div className="result-box">
                                    <h3 className="text-center md:text-left text-[40px] font-secondary font-bold leading-[42px]">45 M</h3>
                                    <p className="text-18 font-medium leading-6 text-center md:text-left text-black opacity-80 pt-1 pb-1">Total Funding</p>
                                </div>
                                <div className="result-box">
                                    <h3 className="text-center md:text-left text-[40px] font-secondary font-bold leading-[42px]">100%</h3>
                                    <p className="text-18 font-medium leading-6 text-center md:text-left text-black opacity-80 pt-1 pb-1">Year on Year Growth</p>
                                </div>
                                <div className="result-box">
                                    <h3 className="text-center md:text-left text-[40px] font-secondary font-bold leading-[42px]">2013</h3>
                                    <p className="text-18 font-medium leading-6 text-center md:text-left text-black opacity-80 pt-1 pb-1">Year Founded</p>
                                </div>
                            </div>
                        </a>
                    </div>
                </div>
            
                <img src="../img/us/logos.webp" width="100%" alt="logos" className="hidden md:flex" data-aos="fade-up" data-aos-delay="200"/>

            </div>
        </section>
);
}

export default ResultSection;